{
  const STORAGE_KEY = 'nearestLocation';

  function applyLocation(element, nearestLocation) {
    const link = `<a href="${nearestLocation.permalink}">${nearestLocation.post_title}</a>`;
    if (element.innerHTML.includes("Loading...")) {
      element.innerHTML = element.innerHTML.replaceAll("Loading...", link);
    } else {
      element.innerHTML = element.innerHTML.replace(/<a\b[^>]*>.*?<\/a>/, link);
    }
  }

  class FavoriteLocation extends HTMLElement {
    connectedCallback() {
      this.postId = this.getAttribute('post-id');
      this.favoritedEl = this.querySelector('[data-favorited]');
      this.unfavoritedEl = this.querySelector('[data-unfavorited]');
      this.addEventListener('click', () => this.toggle());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle();
        }
      });
      this.render();
    }
 
    get isFavorite() {
      const cached = localStorage.getItem(STORAGE_KEY);
      return cached && String(JSON.parse(cached).post_id) === String(this.postId);
    }
 
    toggle() {
      const location = {
        post_id: this.postId,
        post_title: this.getAttribute('post-title'),
        permalink: this.getAttribute('permalink'),
        address: this.getAttribute('address') ?? '',
        phone: this.getAttribute('phone') ?? ''
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(location));
      document.querySelectorAll('favorite-location').forEach(el => el.render());
      document.querySelectorAll('.nearest-location').forEach(el => applyLocation(el, location));
      document.dispatchEvent(new CustomEvent('nearest-location-change', { detail: location }));
    }
 
    render() {
      const favorited = this.isFavorite;
      if (this.favoritedEl) this.favoritedEl.style.display = favorited ? '' : 'none';
      if (this.unfavoritedEl) this.unfavoritedEl.style.display = favorited ? 'none' : '';
      this.setAttribute('aria-label', favorited ? 'Remove favorite location' : 'Set as favorite location');
    }
  }
 
  customElements.define('favorite-location', FavoriteLocation);
}